import { FileReader, FileWriter } from '@/platform'

class CustomUIImageStyle{
  public Index: number = 0;
  public imagePath: string = ""; //图片路径
  public X: number = 0; //图片x坐标
  public Y: number = 0; //图片y坐标
  /** 与 cg_v3 @DataStrucrParse("ImagePath","string",5) 对应 */
  public ImagePath: string = "";

  constructor(
    param?:
      | {
          path: string;
          x: number;
          y: number;
        }
      | FileReader
  ) {
    if (param && "path" in param) {
      const { path, x, y } = param;
      this.Index = 0;
      this.imagePath = path;
      this.ImagePath = path;
      this.X = x;
      this.Y = y;
    } else if (param instanceof FileReader) {
      this.readBin(param)
    } else {
      this.imagePath = "";
      this.X = 0;
      this.Y = 0;
    }
  }

  readBin(reader: FileReader): void {
    this.Index = reader.readInt()
    this.imagePath = reader.readString()
    this.X = reader.readInt()
    this.Y = reader.readInt()
    this.ImagePath = reader.readString()
  }

  writeBin(writer: FileWriter): void {
    writer.writeInt(this.Index)
    writer.writeString(this.imagePath)
    writer.writeInt(this.X)
    writer.writeInt(this.Y)
    writer.writeString(this.ImagePath)
  }
}

export default CustomUIImageStyle;
